import {
  GET_TYPESREGULATION,
  GET_TYPESREGULATION_FAIL,
  GET_TYPESREGULATION_SUCCESS,
  GET_TYPESREGULATIONS,
  GET_TYPESREGULATIONS_FAIL,
  GET_TYPESREGULATIONS_SUCCESS,
  ADD_NEW_TYPESREGULATION,
  ADD_TYPESREGULATION_SUCCESS,
  ADD_TYPESREGULATION_FAIL,
  UPDATE_TYPESREGULATION,
  UPDATE_TYPESREGULATION_SUCCESS,
  UPDATE_TYPESREGULATION_FAIL,
  DELETE_TYPESREGULATION,
  DELETE_TYPESREGULATION_SUCCESS,
  DELETE_TYPESREGULATION_FAIL,
  SET_STATE_TYPESREGULATION,
  UPDATE_TYPESREGULATION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_TYPESREGULATION,
  payload: loading,
})

export const getTypesRegulations = ( params ) => ({
  type: GET_TYPESREGULATIONS,
  payload: { params },
})

export const getTypesRegulationsSuccess = (typesRegulations, totalPages, currentPage) => ({
  type: GET_TYPESREGULATIONS_SUCCESS,
  payload: {typesRegulations:typesRegulations, total:totalPages, currentPage:currentPage}
})

export const getTypesRegulationsFail = error => ({
  type: GET_TYPESREGULATIONS_FAIL,
  payload: error,
})

export const addNewTypesRegulation = typesRegulation => ({
  type: ADD_NEW_TYPESREGULATION,
  payload: typesRegulation,
})

export const addTypesRegulationSuccess = typesRegulation => ({
  type: ADD_TYPESREGULATION_SUCCESS,
  payload: typesRegulation,
})  

export const addTypesRegulationFail = error => ({
  type: ADD_TYPESREGULATION_FAIL,
  payload: error,
})

export const updateTypesRegulation = typesRegulation => ({
  type: UPDATE_TYPESREGULATION,
  payload: typesRegulation,
})

export const updateTypesRegulationStatus = typesRegulation => ({
  type: UPDATE_TYPESREGULATION_STATUS,
  payload: typesRegulation,
})

export const updateTypesRegulationSuccess = typesRegulation => ({
  type: UPDATE_TYPESREGULATION_SUCCESS,
  payload: typesRegulation,
})

export const updateTypesRegulationFail = error => ({
  type: UPDATE_TYPESREGULATION_FAIL,
  payload: error,
})

export const deleteTypesRegulation = typesRegulation => ({
  type: DELETE_TYPESREGULATION,
  payload: typesRegulation,
})

export const deleteTypesRegulationSuccess = id => ({
  type: DELETE_TYPESREGULATION_SUCCESS,
  id,
})

export const deleteTypesRegulationFail = error => ({
  type: DELETE_TYPESREGULATION_FAIL,
  payload: error,
})

export const getTypesRegulation = () => ({
  type: GET_TYPESREGULATION,
})

export const getTypesRegulationSuccess = typesRegulation => ({
  type: GET_TYPESREGULATION_SUCCESS,
  payload: typesRegulation,
})

export const getTypesRegulationFail = error => ({
  type: GET_TYPESREGULATION_FAIL,
  payload: error,
})
